export { default as classname } from './classname';
export { classnames } from '@bem-react/classnames';

/**
 * Вывод текста в нужном типе
 * @param content
 * @returns {{children: *}|{dangerouslySetInnerHTML: {__html: string}}}
 */
export const raw = content => {
  if (typeof content === 'string') {
    return { dangerouslySetInnerHTML: { __html: content } };
  } else {
    return { children: content };
  }
};
